import { Button, Modal, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import React, { useContext, useEffect, useRef, useState } from "react";
import CustomForm from "../CustomForm";
import { userHasLevel } from "../../../engine/AuthRoute";
import { roles } from "../../../utils/constants";
import { createPortal } from "react-dom";
import { modalsByContext } from "./modals";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { UserContext } from "../../../engine/context/User.context";
import { FiCheckCircle } from "react-icons/fi";
import { typeAddress } from "../../container/Addresses/AddresseItem/AddresseHelpers";
import { inputsAddresseItem } from "../../container/Addresses/AddresseItem/AddresseItemInputs";
import { newAddresse } from "../../container/Addresses/AddressesSlice/Addresses.slice";
import { addresseItemMapsInputs } from "../../container/Addresses/AddresseItem/AddresseItemMapsInputs";
import { truncateDecimal } from "../../../utils/helpersFunction";
import { useTranslation } from "react-i18next";

export const InstitutionNewAddress = ({ defaultOpen }) => {
  const { t } = useTranslation(); // Initialize useTranslation
  const [open, setOpen] = useState(defaultOpen);

  useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  const { institution } = useSelector(state => state.institution);
  const { user } = useContext(UserContext);

  const formRef = useRef(null);

  const context = useContext(ModalContext);
  const { params } = context;
  const { type } = params;
  const dispatch = useDispatch();
  const close = params => {
    setOpen(false);
    context.closeModal(modalsByContext.InstitutionNewAddress, params);
  };
  const onSubmitForm = async data => {
    const allDatas = formRef.current.getFieldsValue(true);
    let payload = {};

    if (type === typeAddress.postal) {
      payload = {
        type,
        institution: params?.institution,
        principal: params?.principal,
        description: data?.description,
        ...data?.address,
        sharedToInstitutions: data?.sharedToInstitutions || [],
      };
    }

    if (type === typeAddress.maps) {
      const allData = formRef.current.getFieldsValue(true);
      let longitude = "";
      let latitude = "";
      let canton = "";

      if (data.maps !== undefined) {
        longitude = truncateDecimal(allData?.lng_maps || 0, 5);
        latitude = truncateDecimal(allData?.lat_maps || 0, 5);
        canton = allData?.canton_maps || "";
      }

      payload = {
        type,
        institution: params?.institution,
        ...data,
        longitude,
        latitude,
        canton,
      };
    }

    let action = await dispatch(newAddresse(payload));

    close({ _id: action?.payload?._id, data: action?.payload });
  };

  const config = {
    key: institution._id + modalsByContext.InstitutionNewAddress,
    containerStyle: { minWidth: "500px" },
    title:
      type === typeAddress.postal
        ? t("institutionNewAddress.newBillingAddress")
        : t("institutionNewAddress.newLocation"),
    open: open,
    width: 1000,
    onOk: () => {
      formRef.current.submit();
    },
    onCancel: close,
    content: (
      <>
        <CustomForm
          refForm={formRef}
          dataSource={
            type === typeAddress.postal
              ? inputsAddresseItem({
                  address: {
                    beneficiary: "",
                  },
                  description: ``,
                })
              : addresseItemMapsInputs({
                  location: "",
                  maps: "",
                })
          }
          labelCol={24}
          handleSubmit={onSubmitForm}
          wrapperCol={24}
        />
      </>
    ),
    footer: [
      <Button key="close" onClick={close}>
        {t("institutionNewAddress.close")}
      </Button>,
      <Button
        icon={<FiCheckCircle size={20} />}
        type="primary"
        onClick={async () => {
          try {
            const test = await formRef.current.validateFields();
            formRef.current.submit();
          } catch (e) {
            notification.error({
              message:
                e.errorFields.length +
                t("institutionNewAddress.requiredFields"),
            });
          }
        }}
      >
        {type === typeAddress.postal &&
          t("institutionNewAddress.createAddress")}
        {type === typeAddress.maps && t("institutionNewAddress.createLocation")}
      </Button>,
    ],
  };

  return (
    <>
      {createPortal(
        <Modal {...config}>{config.content}</Modal>,
        document.querySelector("#modals"),
      )}
    </>
  );
};

export const prestationCommentAdminInputs = prestation => {
  const {
    intervention: { startDate, endDate, location, extra },
    comment,
  } = prestation;

  return [
    {
      hidden: !userHasLevel({
        only: {
          [roles.admin]: "crud", //
          [roles.permanance]: "crud", //
        },
      }),
      children: [
        {
          label: t("prestationCommentAdminInputs.adminComment"),
          name: "comment.admin",
          hidden: !userHasLevel({
            only: {
              [roles.admin]: "crud", //
              [roles.permanance]: "crud", //
            },
          }),
          value: comment.admin,
          type: "textarea",
          row: 2,
          col: 24,
        },
      ],
    },
  ];
};
